<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-card
    class="pa-2 d-flex flex-column justify-end"
    color="transparent"
    elevation="0"
    style="position:relative"
    tile
  >
    <apex-chart
      v-if="graphIsReady"
      :options="options"
      :series="series"
      height="400"
      type="area"
    />
  </v-card>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'ReservationChart',
  props: {
    dailyInfo: {
      type: Array
    }
  },
  data: function () {
    return {
      series: [],
      options: {},
      graphIsReady: false
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph: async function () {
      this.graphIsReady = false
      this.series = [
        {
          name: this.$t('SpecifiedQuantity'),
          data: this.dailyInfo.map(it => {
            return {
              x: dayjs(it.reserveDate).format('MM-DD'),
              y: it.reserveCount.toFixed(0)
            }
          })
        },
        {
          name: this.$t('NumberOfArrivals'),
          data: this.dailyInfo.map(it => {
            return {
              x: dayjs(it.reserveDate).format('MM-DD'),
              y: it.arriveCount.toFixed(0)
            }
          })
        }
      ]

      this.options = {

        colors: [
          '#fbdc46',
          '#ffffff'
        ],

        plotOptions: {
          bar: {
            columnWidth: '70%'
          }
        },
        chart: {
          toolbar: {
            show: false
          }

        },
        yaxis: {
          show: false
        },

        grid: {
          show: false
        },
        legend: {
          show: false
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          theme: 'dark'
        },
        xaxis: {
          type: 'category',
          labels: {
          },
          axisTicks: {
            show: false
          }
        }

      }
      this.graphIsReady = true
    }
  }
}
</script>

<style scoped>

</style>
